import React from "react";
import Toast from "react-bootstrap/Toast";

import FilterOverlay from "./FilterOverlay";
import Thumbnail from "../../editor/Thumbnail";
import { Filters, DisplayFilters } from "../../filters";

import AddCategoryModal from "../../modal/AddCategoryModal";
import CategoryMenuModal from "../../modal/CategoryMenuModal";
import DeleteFilterModal from "../../modal/DeleteFilterModal";

import IconAdd from "../../icons/toolbar/menu/filter/Add";
import IconFavourite from "../../icons/toolbar/menu/filter/Favourite";

import Backend from "../../../../utils/Backend";

export default class PhotoStrip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      type: props.type,
      filter: props.filter,
      categoryId: props.categoryId,
      showAddedToFavNotif: false,
      showCategoryMenuModal: false,
      showCategoryAddNameModal: false,
    };
    this.handleLongButtonPress = this.handleLongButtonPress.bind(this);
    this.handleLongButtonRelease = this.handleLongButtonRelease.bind(this);
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps;
  }

  componentDidMount() {
    this._loadFilters();
  }

  _loadFilters() {
    let { type, categoryId } = this.state;

    Backend.getFilters(type, categoryId).then((filters) => {
      this.setState({ filters });
    });
  }

  handleLongButtonPress(e, item) {
    e.preventDefault();
    this.longPressTimer = setTimeout(() => {
      if (item.key === "none") {
        return;
      } else if (this.state.categoryId === "Favourites") {
        this.setState({ showDeleteFilterModal: true, selectedFilter: item });
      } else {
        this.setState({ showOverlay: true, filter: item });
      }
    }, 1000);
  }

  handleLongButtonRelease() {
    clearTimeout(this.longPressTimer);
  }

  _getActiveClassName(item) {
    let { filter, showOverlay } = this.state;

    if (item.data.type === "Lightroom") {
      return filter.id === item.id ? "active" : "";
    } else {
      if (!showOverlay) {
        return filter.id === item.id ? "active" : "";
      }
      return filter.id === item.id ? "active long-pressed" : "";
    }
  }

  _showOverlay(item) {
    let { filter, showOverlay } = this.state;
    if (filter?.title === "Original") {
      return false;
    }
    return filter?.type === item.data.type && showOverlay;
  }

  _renderImage(filter) {
    // let image = IMAGES.find((image) => image.type == filter.type);
    let url = this.props.image;
    url = url.replace("400x225", "100x100");

    return <Thumbnail image={url} filter={filter.data} />;
  }

  _getIntensity(type) {
    let intensity = 0.8;
    if (
      type === "BlackAndWhite" ||
      type === "BlackAndWhiteV2" ||
      type === "BlackAndWhiteGrain" ||
      type === "BlackAndWhiteGrainV2"
    ) {
      intensity = 1;
    }
    return intensity;
  }

  _renderFilters() {
    let { filter, filters, categoryId } = this.state;
    return filters.map((item) => {
      return (
        <div key={item.id}>
          <div
            key={item.className}
            className={`photo ${this._getActiveClassName(item)}`}
            onTouchStart={(e) => this.handleLongButtonPress(e, item)}
            onTouchEnd={this.handleLongButtonRelease}
            onMouseDown={(e) => this.handleLongButtonPress(e, item)}
            onMouseUp={this.handleLongButtonRelease}
            onMouseLeave={this.handleLongButtonRelease}
            onClick={() => {
              if (filter.id === item.id) {
                return;
              }

              let data = {
                ...Filters[item.data.type],
                ...item.data,
              };

              let selectedFilter = {
                data,
                id: item.id,
                key: item.key,
                type: item.data.type,
                name: item.name,
                intensity: this._getIntensity(item.data.type),
              };

              this.setState({ filter: selectedFilter }, () => {
                this.props.onSelected(selectedFilter);
              });
            }}
          >
            <div className="asset" style={{ overflow: "hidden" }}>
              {this._renderImage(item)}
            </div>
            <span>{item.name}</span>
            {this._showOverlay(item) && (
              <>
                <div
                  className={this.state.showOverlay ? "mask" : ""}
                  onClick={() => this.setState({ showOverlay: false })}
                />
                {/* //TODO: Display the section when implemented */}
                <span className="actions">
                  <a
                    className="action"
                    href="javascript:void(0)"
                    onClick={() => {
                      this.setState({
                        showOverlay: false,
                        showAddedToFavNotif: true,
                      });
                      Backend.addFavouriteFilter({ ...filter });
                    }}
                  >
                    {categoryId !== "Favourites" ? (
                      <IconFavourite className="" />
                    ) : null}
                  </a>
                  <a
                    className="action"
                    href="javascript:void(0)"
                    onClick={() => {
                      this.setState({
                        showOverlay: false,
                        selectedFilter: item,
                        showCategoryMenuModal: true,
                      });
                    }}
                  >
                    <IconAdd className="" />
                  </a>
                </span>
              </>
            )}
          </div>
        </div>
      );
    });
  }

  render() {
    let { selectedFilter, categoryId } = this.state;
    return (
      <>
        <div className="photo-strip">{this._renderFilters()}</div>

        {this.state.showAddedToFavNotif && (
          <Toast className="p-btm">
            <Toast.Body>
              <div className="row m-0 align-items-center">
                <div className="col">Filter added to Favourites</div>
                <div className="col-auto p-0">
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => {
                      this.setState((prevState) => ({
                        showAddedToFavNotif: !prevState.showAddedToFavNotif,
                      }));
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Toast.Body>
          </Toast>
        )}

        <CategoryMenuModal
          show={this.state.showCategoryMenuModal}
          filter={selectedFilter}
          onHide={() => this.setState({ showCategoryMenuModal: false })}
          onNewCategoryClick={() => {
            this.setState({
              showCategoryMenuModal: false,
              showCategoryAddNameModal: true,
            });
          }}
          onAdded={() => {
            this.props.onCategoriesUpdated();
            this.setState({ showCategoryMenuModal: false });
          }}
        />

        <AddCategoryModal
          show={this.state.showCategoryAddNameModal}
          filter={selectedFilter}
          onHide={() => this.setState({ showCategoryAddNameModal: false })}
          onAdded={() => {
            this.props.onCategoriesUpdated();
            this.setState({ showCategoryAddNameModal: false });
          }}
        />

        <DeleteFilterModal
          show={this.state.showDeleteFilterModal}
          filter={selectedFilter}
          onHide={() => this.setState({ showDeleteFilterModal: false })}
          onDeleted={() => {
            this.props.onCategoriesUpdated();
            this._loadFilters();
            this.setState({ showDeleteFilterModal: false });
          }}
        />
      </>
    );
  }
}
